var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSparkleAiFilled = function SvgSparkleAiFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    d: "M5.573 2.364a.833.833 0 0 0-1.645 0c-.083.506-.266.846-.498 1.075-.233.23-.572.407-1.065.489a.833.833 0 0 0 0 1.644c.506.083.845.266 1.075.498.23.233.407.572.488 1.065a.833.833 0 0 0 1.645 0c.08-.493.258-.832.488-1.065.23-.232.569-.415 1.075-.498a.833.833 0 0 0 0-1.644c-.506-.084-.845-.267-1.075-.499-.23-.232-.407-.572-.488-1.065Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    d: "M11.577 2.395a.833.833 0 0 0-1.653 0c-.269 2.112-.839 3.634-1.766 4.702-.914 1.053-2.26 1.762-4.287 2.08a.833.833 0 0 0 0 1.646c2.026.318 3.373 1.026 4.287 2.08.927 1.068 1.497 2.59 1.766 4.702a.833.833 0 0 0 1.653 0c.268-2.112.838-3.634 1.765-4.702.915-1.054 2.261-1.762 4.287-2.08a.833.833 0 0 0 0-1.646c-2.136-.336-3.484-1.089-4.373-2.155-.905-1.086-1.421-2.6-1.679-4.627Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSparkleAiFilled);
export default ForwardRef;